export default "__VITE_ASSET__bc1b6b81__"